import { AfterViewInit, Component } from '@angular/core';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa0050.component.html',
  styleUrls: ['wa0050.component.css']
})
export class Wa0050Component implements AfterViewInit {
  public componentTitle = 'WA0050:データマッピング(種別選択)';

  private working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  private production = environment.production;
  private backgroundColor: string;
  private updprogramCd = 'wa0050';

  private filetypes;

  private uploadObjectId = 0;
  private errorInfo = '';

  // const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

  constructor(private interfaceMappingService: InterfaceMappingService, private commonService: CommonService, private router: Router, private dialogsService: DialogsService) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    this.interfaceMappingService
      .uploadobjects()
      .then(outputJson => {
        this.working = false;
        console.log(outputJson);
        this.filetypes = outputJson.uploadobjects;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onSubmit() {
    // tslint:disable-next-line:prefer-const
    let matchData = this.filetypes.filter(function(item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.uploadObjectId == this) {
        return true;
      }
    }, this.uploadObjectId);

    if (matchData.length === 0) {
      this.errorInfo = 'マッピング種別を選択してください。';
      return;
    }

    sessionStorage.setItem('uploadobjects', JSON.stringify(matchData[0]));

    this.router.navigate(['wa0051']);
  }

  onDelete() {
    // tslint:disable-next-line:prefer-const
    let matchData = this.filetypes.filter(function(item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.uploadObjectId == this) {
        return true;
      }
    }, this.uploadObjectId);

    if (matchData.length === 0) {
      this.errorInfo = 'マッピング種別を選択してください。';
      return;
    }

    console.log(JSON.stringify(matchData[0]));

    sessionStorage.setItem('uploadobjects', JSON.stringify(matchData[0]));

    this.router.navigate(['wa0054']);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0050/wa0050.component.ts